import { api } from '@/api'
import Button from '@/components/Button'
import Input from '@/components/Input'
import { useFormik } from 'formik'
import Spinner from '@/components/Spinner/Spinner'
import { GxForm } from '@garpix/garpix-web-components-react'
import React from 'react'
import { Link } from 'react-router-dom'
import style from '../styles/auth.module.scss'
import { loginSchema } from '@/utils/schemesFormik'

const AuthorizationForm = ({
  redirectPage = '/',
  forgotPasswordUrl = '/'
}): React.ReactElement => {
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: loginSchema,
    initialValues: {
      login: '',
      password: '',
      apiError: ''
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit (values, { setSubmitting, setErrors }) {
      api
        .login({
          login: values.login,
          password: values.password
        })
        .then(() => {
          setSubmitting(false)
          window.location.href = redirectPage
        })
        .catch((err: any) => {
          setErrors({ apiError: err?.response?.data?.errorText })
          setSubmitting(false)
        })
    }
  })

  const onSubmit = formik.submitForm
  return (
    <GxForm onGx-submit={onSubmit}>
      <Input
        label='Логин:'
        type='text'
        name='login'
        value={formik.values.login}
        onGx-input={formik.handleChange}
        required
        className={style.form__input}
        error={formik.errors.login}
      />
      <Input
        label='Пароль:'
        type='password'
        name='password'
        value={formik.values.password}
        onGx-input={formik.handleChange}
        required
        className={style.form__input}
        error={formik.errors.password}
      />
      <Button
        wide
        highlight
        size='extralarge'
        type='submit'
        className={style.form__button}
        disabled={formik.isSubmitting}
      >
        {formik.isSubmitting ? <Spinner /> : 'Войти'}
      </Button>
      <div className={style.form__flex}>
        {formik?.errors?.apiError === ''
          ? undefined
          : (
            <span className={style.form__error}>{formik.errors.apiError}</span>
            )}
        <Link to={forgotPasswordUrl} className={style.form__remember}>
          Забыли пароль или логин?
        </Link>
      </div>
    </GxForm>
  )
}

export default AuthorizationForm
